import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Dropzone from 'react-dropzone'
import CloseButton from 'components/atoms/buttons/CloseButton'
import ImageUploadRejected from 'components/atoms/ImageUploadRejected'
import ImageUploadPlaceholder from 'components/atoms/ImageUploadPlaceholder'

const styles = theme => ({
  root: {
    width: 328,
    height: 168,
    position: 'relative',
    marginBottom: theme.spacing(1),
  },
  title: {
    ...theme.typography.field.title,
  },
  image: {
    display: 'block',
    width: 'auto',
    height: '100%',
    verticalAlign: 'bottom',
    margin: '0 auto',
  },
  dropzone: {
    width: '100%',
    height: '100%',
    borderRadius: 8,
    cursor: 'pointer',
    overflow: 'hidden',
    border: '2px dashed #ddd',
    transition: 'background-color .1s ease',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main}10`,
    },
  },
  activeZone: {
    borderColor: theme.palette.primary.main,
    backgroundColor: `${theme.palette.primary.main}10`,
  },
  removeButton: {
    position: 'absolute',
    top: '0',
    right: '0',
    transform: 'translate(50%, -50%)',
    transition: 'opacity 0.3 ease',
    opacity: 0,
    pointerEvents: 'none',
    zIndex: 1,
  },
  removeButtonVisible: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  error: {
    color: theme.palette.error.main,
  },
  zoneError: {
    border: `2px dashed ${theme.palette.error.main}75`,
  },
})

const ImageUpload = ({
  classes,
  hasImage,
  imageSrc,
  onDrop,
  onSelect,
  onRemove,
  error,
  helperText,
}) => (
  <div className={classes.root}>
    {onRemove && (
      <CloseButton
        className={classNames(
          classes.removeButton,
          hasImage ? classes.removeButtonVisible : null
        )}
        onClick={onRemove}
      />
    )}
    <Dropzone
      onDrop={onDrop}
      multiple={false}
      onSelect={onSelect}
      maxSize={2097152} // 2MB
      onDropRejected={onRemove}
      activeClassName={classes.activeZone}
      accept="image/png, image/jpeg, image/jpg"
      className={classNames(classes.dropzone, error && classes.zoneError)}>
      {({ rejectedFiles }) => {
        return hasImage ? (
          <img
            src={imageSrc}
            alt="Project logo"
            className={classes.image}
          />
        ) : rejectedFiles.length ? (
          <ImageUploadRejected errorText="File must be png, jpeg or jpg format and smaller than 2MB" />
        ) : (
          <ImageUploadPlaceholder helperText={helperText} />
        )
      }}
    </Dropzone>
  </div>
)

ImageUpload.propTypes = {
  meta: PropTypes.object,
  onDrop: PropTypes.func,
  error: PropTypes.string,
  input: PropTypes.object,
  imageSrc: PropTypes.any,
  hasImage: PropTypes.bool,
  onSelect: PropTypes.func,
  onRemove: PropTypes.func,
  classes: PropTypes.object,
  helperText: PropTypes.string,
}

export default withStyles(styles)(ImageUpload)



// WEBPACK FOOTER //
// ./src/components/organisms/ImageUpload/ImageUpload.js